import { useContext } from 'react';
import { AssigneeDropdownCnt } from 'components/AllDialogs/tasks/editTask/createTask.style';
import CreateEditTaskAssigneeDropdown from 'components/common/jsxrender/task/CreateEdit/CreateEditAssigneeDropdown';
import { CreateTaskContext } from 'components/AllDialogs/tasks/editTask/context/context';

const TaskAssigneeDropdown = () => {
  const { updateTask, newTask } = useContext(CreateTaskContext);
  const handleUpdateAssignee = async (values) => {
    updateTask({ assignees: values });
  };
  return (
    <AssigneeDropdownCnt>
      <label>Assignee:</label>
      <CreateEditTaskAssigneeDropdown
        handleChangeCallback={handleUpdateAssignee}
        assignees={newTask?.assignees || []}
        task={newTask}
      />
    </AssigneeDropdownCnt>
  );
};

export default TaskAssigneeDropdown;
